<template>
    <div class="wrapper">        
        <h1 class="title">Identity Verification</h1>
                       
        <Upload 
            :needShowList='obj["ada_front"]'
            title= "Aadhaar Front"
            :requestId="requestId"
            invoke_type = '1'
            type_txt = 'ada_front'
            @set_value=set_value
            fromPage="kyc_page"
            name="front"        
            @refreshRequestId = "refreshRequestId"
        ></Upload> 
        <!-- <Upload 
            :needShowList='obj["face"]'
            title= "Face Recognition"
            invoke_type = '5'
            type_txt = 'face'
            @set_value=set_value
            fromPage="kyc_page"
            name="face" 
            @refreshRequestId = "refreshRequestId"
        ></Upload>          -->
        <div class="input-container" v-for="(item, ind) in select_types" :key="ind">
            <MyInput
                :title="item.key"
                :component_id = ind
                :required="item.checkReq"
                :keys="item.value"
                :label="item.label"
                :is_show="item.is_show"
                :is_error="item.is_error"
                :checkType="item.checkType"
                :maxlength="item.lengthLimitMax"
                fromPage = "kyc_input_page"
                :eventCount = item.eventCount
                :requestId = "requestId"
                @setCount="setCount"
                @modifyError="modify_error"
                @setValue="setValue"
                @refreshRequestId="refreshRequestId"
            ></MyInput>
        </div>
                     
        <div class="placeholder"></div>
        <div class="btn-container">            
            <a class='btn-submit' @click="submit">CONFIRM TO NEXT</a>
        </div>
        
    </div>
</template>
<style lang="less" scoped>
.input-container{
    width: 620px;
    background:#fff;
    border-radius: 15px;
    padding:20px 20px;
}
.changetouploda-text{
    display: block;
    width: 400px;
    text-align: center;
    font-size:26px;
    color:#FF5715;
    margin:50px auto;
    text-decoration: underline;
}
.btn-container{
        position: fixed;
        left:0;
        bottom: 0;        
        background:#fff;
        padding:40px;
        // padding:40px;
        .btn-submit{
            display: block;
            width: 670px;
            height: 96px;
            line-height: 96px;
            text-align: center;
            border-radius: 12px;
            background:#FF5715;
            font-size: 32px;
            margin:0 auto;
            color:#fff;
        }
    }
    .placeholder{
        height: 176px;        
    }
    .hih-caption{
        color:#A59BB3;
        font-size:28px;
        margin-bottom: 30px;
        line-height: 1.5;
    }
    .wrapper{
        padding:20px 40px;
        .guide{
            color:#A59BB3;
            font-size: 30px;
            em{
                color:#FF5715;
                font-weight: 700;
            }
        }
        .title{
            color:#1F201E;
            font-weight: 700;
            font-size: 40px;
            margin: 0 0 50px 0;  
        }
    }
</style>
<script>
import Upload from '@/components/business/kyc/upload.vue'
import MyInput from '@/components/business/kyc/input.vue'
import { onMounted, reactive, getCurrentInstance,ref,onBeforeMount,onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { key_submit } from '@api/index'
import { useLoading } from 'vue-loading-overlay'
import { getActiveResult, faceConfig } from '@api/index';
import { v4 as uuidv4} from 'uuid'
import { useStore } from 'vuex'
export default {
    components:{
        Upload,
        MyInput
    },
    props:{
        step:String,
        allstep:String
    },
    setup(props, ctx) {
        const $loading = useLoading()
        const clicked = ref(false)
        const router = useRouter()
        const route = router.currentRoute
        const proxy = getCurrentInstance().proxy        
        const select_types = reactive([{
            "key": "PAN ID",
            "label": "PAN ID",
            "value": "panNo",
            "dataType": "1",
            "checkType": "0",
            "lengthLimitMin": 0,
            "lengthLimitMax": 10,
            "checkReq": 0,
            "identifyValue": true,
            "modifyValue": true,
            "dictionaryVoList": null,
            "eventCount":0
        }])
        
        const obj = reactive({
            "params":{
                "panNo":{
                    "value":'',
                    "ind": 0,
                    "required":true
                }
            },
            "ada_front": {
                "file_name":"",
                "needToShow":[]
            },
            "face": {
                "file_name":"",
                "needToShow":[]

            },
            "pan": {
                "file_name":"",
                "needToShow":[]
            },            
        })  
        console.log();
        let requestId = ref(uuidv4())
        const store = useStore()
        const config = reactive({
            living_type:null
        })      
        const setValue = (k, v) => {               
            obj.params[k].value = v
            // validate()
        }
        onBeforeMount(()=>{
            store.dispatch('bury', {eventId:"kyc_page_view"})
            store.dispatch("clearBuryCache", [])
            
        })
        onBeforeUnmount(()=>{
            store.dispatch('bury', {eventId:"kyc_exit_page_tech"})
            store.dispatch("clearBuryCache", [])
        })
        const changeVerify = () => {
            ctx.emit("changeState", 0)
        }
        onMounted(async () => {
            
            document.body.style.background = '#F8F8F8'
            const data = await faceConfig()            
            config.living_type = data.data['living-config']
            if (config.living_type == 1) {
                getActiveResult()
            }
            
        })
        const validate = () => {
            let res = true
            if(obj['ada_front']['file_name']== '') {
                proxy.$toast.show('Please take Aadhaar front')
                res =false
            }
            //  else if (obj['ada_back']['file_name'] == '') {
            //     proxy.$toast.show('Please Upload Aadhaar Back ')
            //     res =false
                
            // } 
            // else if ( obj['face']['file_name'] == '' ){
            //     proxy.$toast.show('Please take Face Recognition ')
            //     res =false
            // } 
            
            return res
        }
        const submit = async () => {
            store.dispatch("bury",{"event_id":"kyc_page_enter_button_click"})
            if(!validate()) return
            if(clicked.value)return 
            clicked.value = true
            const loader = $loading.show({
                container: null
            })
            let data = await key_submit({
                "type":1,
                "panNo":obj.params['panNo'].value
            })
            loader.hide()
            clicked.value = false
            if(data.code == 0) {
                store.dispatch("bury",{"event_id":"kyc_info_enter_button_click_success"})
                store.dispatch("uploadBury")                         
                router.replace({
                    "path":"/auth/index",
                    "query":{
                        "pid":route.value.query.pid
                    }
                })                         
            } else {
                proxy.$toast.show(data.msg)
                store.dispatch("bury",{"event_id":"kyc_info_enter_button_click_success",message:data.msg})
                
            }
        }

        const set_value = (key, v) => {
            obj[key] = v
        }
        const refreshRequestId = () => {
            requestId.value = uuidv4()
        }
        const setCount = (ind, count) => {
            select_types[ind].eventCount = count
        }
        const modify_error = (k,v) =>{
            v = false
            select_types[k]['is_error'] = v
        }
        
        return {
            setValue,
            modify_error,
            refreshRequestId,
            setCount,
            obj,
            set_value,
            submit,
            validate,
            config,
            requestId,
            props,
            changeVerify,
            select_types
        }
        
    }
}
</script>